import { createRef, useEffect, useRef } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { useMessages } from "../../../contexts/MessageContext";
import ChatMessage from "../ChatMessage/ChatMessage";
import "./Chat.css";

const Chat = ({isLoggedIn}) => {
  const containerRef = useRef(null);
  const {messages, addMessage, updateMessage} = useMessages();

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [messages]);

  /*   useEffect(() => {
    setTimeout(() => {
      const fetchHello = async () => {
        try {
          const response = await getHello();
          addMessage({type: "text", content: response.message});
          console.log(response);
        } catch (error) {
          toast.error("Ошибка при подключении к серверу");
        }
      };
      fetchHello();
    }, 5000);
  }, [isLoggedIn]); */

  return (
    <div className='chat'>
      <div className='chat-window__wrapper'>
        <div className='chat-window' ref={containerRef}>
          <TransitionGroup className='messages-container'>
            {messages.map((msg, index) => {
              const nodeRef = createRef();
              return (
                <CSSTransition key={msg.id || index} nodeRef={nodeRef} timeout={500} classNames='fade'>
                  <div ref={nodeRef}>
                    <ChatMessage message={msg} />
                  </div>
                </CSSTransition>
              );
            })}
          </TransitionGroup>
        </div>
      </div>
      {/* <UploadForm /> */}
    </div>
  );
};

export default Chat;
